/* eslint-disable no-restricted-syntax */
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Loader } from '../../../../components/Loader';
import {
  applyAutotelexOptionsToVehicle,
  fetchVehicle,
  fromAutotelex,
  searchAutotelex,
  setVehicleProperties,
} from '../../actions';
import { selectVehicle, selectNewVehicle } from '../../selectors';
import { VehicleEditInner } from './editInner';
import { AUTOTELEX_VEHICLE_PURPOSE, VEHICLE_PURPOSE } from '../../constants';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';


const STATE = {
  step: 1,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleEditComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetch();
    if (!this.props.match.params.step) {
      this.to(`/vehicles/${this.props.vehicle_id}/edit/${this.state.step}`);
    }
    this.setState({ step: +this.props.match.params.step });
  }

  componentDidUpdate(prevState) {
    if (env.clientId == AppClientId.INDEWAL) {
    if (this.state.step === 7) {
      this.to(`/vehicles/${this.props.vehicle_id}`);
    }}
    else {
    
      if (this.state.step === 6) {
        this.to(`/vehicles/${this.props.vehicle_id}`);
    }}
    prevState.step !== this.state.step ? this.to(`/vehicles/${this.props.vehicle_id}/edit/${this.state.step}`) : null;
  }

  getVehicleFromAutotelex() {
    let properties = [];
    for (let i in this.props.values) {
      if (this.props.values[i] != '')
        properties.push({
          propertyName: i,
          propertyValue: this.props.values[i],
        });
    }

    this.props.searchAutotelex({ regplate: this.props.values?.regplate }, res => {
      if (!!res) {
        if (res?.ownerHistory) {
          properties.push({
            propertyName: 'ownerHistory',
            propertyValue: JSON.stringify(res?.ownerHistory),
          });
        }
        let vehiclePurpose = res?.properties?.find(p => p.propertyName == AUTOTELEX_VEHICLE_PURPOSE.PropertyName);

        if (vehiclePurpose?.propertyValue == AUTOTELEX_VEHICLE_PURPOSE.Passenger) {
          properties.push({
            propertyName: VEHICLE_PURPOSE.PropertyName,
            propertyValue: VEHICLE_PURPOSE.Passenger,
          });
        }

        if (vehiclePurpose?.propertyValue == AUTOTELEX_VEHICLE_PURPOSE.Commercial) {
          properties.push({
            propertyName: VEHICLE_PURPOSE.PropertyName,
            propertyValue: VEHICLE_PURPOSE.Commercial,
          });
        }

        return this.props.fetchFromAutotelex(this.props.values.regplate, () => {
          this.props.patch(properties, result => {});
          this.props.applyOptions(this.props.values.regplate, this.props.vehicle_id);
          this.to(`/vehicles/${this.props.vehicle_id}/edit/1`);

          //apply options ...
        });
      }
    });
  }

  nextStep() {
    this.setState(prevState => ({
      step: prevState.step + 1,
    }));
  }

  prevStep() {
    this.setState(prevState => ({
      step: prevState.step - 1,
    }));
  }

  render() {
    if (!this.props.vehicle) {
      return <Loader small />;
    }
    return (
      <VehicleEditInner
        nextStep={this.nextStep.bind(this)}
        prevStep={this.prevStep.bind(this)}
        fetchFromAutotelex={this.getVehicleFromAutotelex.bind(this)}
        step={+this.props.match.params.step}
        vehicle_id={this.props.vehicle_id}
        vehicle={this.props.vehicle}
      />
    );
  }
}

VehicleEditComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    vehicle: selectVehicle(ownProps.vehicle_id),
    values: selectNewVehicle(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchVehicle(ownProps.vehicle_id));
    },
    fetchFromAutotelex(regplate, callback) {
      dispatch(fromAutotelex(ownProps.vehicle_id, regplate, callback));
    },

    searchAutotelex(dto, callback) {
      dispatch(searchAutotelex(dto, callback));
    },

    applyOptions(regplate, vehicleId, callback) {
      dispatch(applyAutotelexOptionsToVehicle(vehicleId, regplate, callback));
    },
    patch(props, callback) {
      dispatch(setVehicleProperties(ownProps.vehicle_id, props, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleEdit = compose(withConnect, withRouter)(VehicleEditComp);
